var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-logo"},[_c('svg-loader',{staticClass:"product-logo-image",attrs:{"src":"/assets/images/hotmart-logotype.svg"}}),_vm._v(" "),_c('div',{staticClass:"product-logo-name"},[_vm._v("\n    hotmart\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }